import { ApiResponseModel, EstacaoMeteorologicaModel, SiloVisaoDetalhadaModel } from 'app/shared/models';

export class RelatorioTermometriaModel {
    silo: ApiResponseModel<SiloVisaoDetalhadaModel>;
    estacao: ApiResponseModel<EstacaoMeteorologicaModel>;
}
